import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import classnames from 'classnames';
import { Theme } from '@app/theme';
import { useFormikError } from './FormikFields';

const useStyles = createUseStyles((theme: Theme) => ({
  error: {
    ...theme.fonts.caption,
    color: theme.colors.red,
  },
  warn: {
    ...theme.fonts.caption,
    color: theme.colors.yellowAccessible,
  },
}));

interface Props {
  error?: string;
  name?: string;
  className?: string;
  variant?: 'warn';
  touched?: boolean;
}

export const ErrorMsg = (props: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ ...props, theme });

  const errorMsg = useFormikError(props);

  if (!errorMsg) {
    return null;
  }

  return (
    <div
      className={classnames(
        {
          [classes.error]: !props.variant,
          [classes.warn]: props.variant === 'warn',
        },
        props.className,
      )}
    >
      {errorMsg}
    </div>
  );
};
